import { useCallback, useState } from 'react';

export const useLocalStorage = <T,>(keyName: string, defaultValue: T) => {
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const value = window.localStorage.getItem(keyName);
      if (value) {
        return JSON.parse(value);
      } else {
        window.localStorage.setItem(keyName, JSON.stringify(defaultValue));
        return defaultValue;
      }
    } catch (err) {
      window.localStorage.removeItem(keyName);
      return defaultValue;
    }
  });

  const setValue = useCallback(
    (newValue: T) => {
      try {
        window.localStorage.setItem(keyName, JSON.stringify(newValue));
      } catch {
        // Ignore localStorage write failures (e.g. private browsing quota).
      }
      setStoredValue(newValue);
    },
    [keyName],
  );

  const deleteValue = useCallback(() => {
    try {
      window.localStorage.removeItem(keyName);
    } catch {
      // Ignore localStorage delete failures.
    }
    setStoredValue('' as T);
  }, [keyName]);

  return [storedValue, setValue, deleteValue];
};
